// İSG uzmanı portalı — Belge Şeması Yönetimi (Document Schemas) erişim kapısı (route guard
// UX). `ContractorsGate.tsx`'in ŞEKLİNİN BİREBİR kopyasıdır (S26 ekran spec'i §3.1).
//
// Asıl yetki backend'dedir (`[ModuleAction("document-schemas", …)]`); bu kapı yalnız UX'tir.

import { Button, Card, CardContent, Spinner } from '@isgportal/shared';
import { FileCog, TriangleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { Link, Outlet } from 'react-router-dom';
import { useDocumentSchemasAccess } from '../../lib/schemasAccess';

export function DocumentSchemasGate() {
  const { t } = useTranslation();
  const access = useDocumentSchemasAccess();

  if (access.status === 'loading') {
    return (
      <div className="flex min-h-[40vh] items-center justify-center">
        <Spinner label={t('documentSchemas.gate.loadingLabel')} />
      </div>
    );
  }

  if (access.status === 'forbidden') {
    return (
      <div className="mx-auto max-w-lg">
        <Card>
          <CardContent className="flex flex-col items-center gap-4 p-8 text-center">
            <FileCog className="h-10 w-10 text-danger" aria-hidden="true" />
            <div className="flex flex-col gap-1.5">
              <h1 className="text-xl font-semibold text-fg">
                {t('documentSchemas.forbidden.title')}
              </h1>
              <p className="text-sm text-muted">{t('documentSchemas.forbidden.body')}</p>
            </div>
            <Button asChild variant="secondary">
              <Link to="/">{t('documentSchemas.forbidden.back')}</Link>
            </Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  if (access.status === 'unavailable') {
    return (
      <div className="mx-auto max-w-lg">
        <Card>
          <CardContent className="flex flex-col items-center gap-4 p-8 text-center">
            <TriangleAlert className="h-10 w-10 text-warning-foreground" aria-hidden="true" />
            <div className="flex flex-col gap-1.5">
              <h1 className="text-xl font-semibold text-fg">
                {t('documentSchemas.unavailable.title')}
              </h1>
              <p className="text-sm text-muted">{t('documentSchemas.unavailable.body')}</p>
            </div>
            <Button onClick={access.refetch}>{t('documentSchemas.unavailable.retry')}</Button>
          </CardContent>
        </Card>
      </div>
    );
  }

  return <Outlet />;
}
